export interface TariffConstraints {
  members: number;
  storage: number;
  rooms?: number;
}

export interface TariffData {
  id: string;
  name: Tariffs;
  base_constraints: TariffConstraints;
  duration: number;
  duration_unit: 'MONTH' | 'DAY' | 'YEAR';
  type: 'rooms' | 'members' | 'storage' | 'simple' | null;
  base_cost: number;
  currency: string;
  room_count?: number;
}

export interface TariffsApiResponse {
  data: TariffData[];
  status?: string;
}

export type ITariff = {
  id: string;
  tariff_name: Tariffs;
  tariff_api_name: string;
  tariff_cost: number;
  tariff_currency: string;
  tariff_duration: number;
  tariff_duration_unit: 'MONTH' | 'DAY' | 'YEAR';
  status?: string;
  tariff_constraints: {
    storage: number;
    members: number;
    rooms?: number;
  };
  type: 'rooms' | 'members' | 'storage' | 'simple' | null;
};

export type QuoteData = {
  id: string;
  user_id: string;
  tariff_plan_id: string;
  name: string;
};

export enum Tariffs {
  Storage = 'storage',
  Trial = 'trial',
  Basic = 'basic',
  Start = 'start', 
  Simple = 'simple',
  Advanced = 'advanced',
  Members = 'members',
  Enterprise = 'enterprise',
  Profile = 'profile',
};

export const profileTariffs: string[] = [
  Tariffs.Storage,
  Tariffs.Simple,
  Tariffs.Members,
];

export const getTariffProfileName = (
  tariff?: { tariff_name?: string; type?: string | null } | null
): string | undefined => {
  if (
    tariff?.tariff_name === Tariffs.Profile &&
    tariff.type &&
    profileTariffs.includes(tariff.type)
  ) {
    return tariff.type;
  }
  return tariff?.tariff_name;
};


export const tariffsData: any[] = [
  {
    key: 'tariff_name',
  },
  {
    key: 'suitable_for',
  },
  {
    key: 'price',
  },
  {
    key: 'number_of_users',
  },
  {
    key: 'storage_capacity',
  },
  {
    key: 'quota_mode',
    current_mode: {
      trial: 'members',
      simple: 'members',
      storage: 'members', 
      members: 'members',
      basic: 'members',
      start: 'members',
      advanced: 'members',
      enterprise: 'members',
    }
  },
  {
    key: 'by_it',
  },
  {
    key: 'you_get',
  },
  {
    key: 'you_get_list',
  },
  {
    key: 'compare_title',
  },
  {
    key: 'room_num',
  },
  {
    key: 'room_members',
  },
  {
    key: 'cloud_storage',
  },
  {
    key: 'additional_storage',
  },
  {
    key: 'preconfigured_roles'
  },
  {
    key: 'back_up',
  },
  {
    key: 'chats',
  },
  {
    key: 'safety_subTitle',
  },
  {
    key: '2FA',
  },
  {
    key: 'SSO',
  },
  {
    key: 'document_encryption',
  },
  {
    key: 'water_marks',
  },
  {
    key: 'user_activity_log'
  },
  {
    key: 'documents_subTitle',
  },
  {
    key: 'base_func',
  },
  {
    key: 'documents_approval',
  },
  {
    key: 'versions'
  },
  {
    key: 'doc_link'
  },
  {
    key: 'timeline'
  },
  {
    key: 'doc_chat'
  },
  {
    key: 'electronic_signature'
  },
  {
    key: 'confident_subTitle',
  },
  {
    key: 'privace_nda',
  },
  {
    key: 'privace_terms',
  },
  {
    key: 'privace_report',
  },


  {
    key: 'integrations_subTitle',
  },
  {
    key: 'integrations_website',
  },
  {
    key: 'integrations_payment',
  },
  {
    key: 'integrations_schedulers',
  },


  {
    key: 'additional_subTitle',
  },
  {
    key: 'contact_list',
  },


  {
    key: 'by_it_2',
  },
];
